var map = {
	"./Clear.svg": 78,
	"./Cloud-wind.svg": 79,
	"./Clouds.svg": 80,
	"./Drizzle.svg": 81,
	"./Mist.svg": 82,
	"./Moon.svg": 83,
	"./Night-rainy.svg": 84,
	"./Night.svg": 85,
	"./Preview.svg": 35,
	"./Rain.svg": 86,
	"./Snow.svg": 87,
	"./Thunderstorm.svg": 88,
	"./Tonado.svg": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;